<template>
  <div
    v-if="data.colors.length > 0"
    class="product-item__colors"
  >
    <p
      :id="identifier"
      class="visually-hidden"
    >
      {{ colorText }}
    </p>
    <ul
      class="product-item__colors-list d-flex"
      :aria-labelledby="identifier"
      v-if="data.onPlp"
    >
      <li
        v-for="(color, index) in data.colors"
        :key="index"
        class="product-item__colors-item"
        @click="data.updateProduct(color)"
      >
        <a
          class="d-flex"
          :class="getSwatchClasses(color)"
          :aria-label="getColorString(color.swatch.color_name)"
        >
          <img
            :src="color.swatch.url"
            :alt="getColorString(color.swatch.color_name)"
          >
        </a>
      </li>
    </ul>
    <ul
      class="product-item__colors-list d-flex"
      :aria-labelledby="identifier"
      v-if="!data.onPlp"
    >
      <li
        v-for="(color, index) in data.colors"
        :key="index"
        class="product-item__colors-item"
      >
        <a
          class="d-flex"
          :href="color.url"
          :class="getSwatchClasses(color)"
          :aria-label="getColorString(color.swatch.color_name)"
        >
          <img
            :src="color.swatch.url"
            :alt="getColorString(color.swatch.color_name)"
          >
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { getColorName } from 'scripts/helpers/product';

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  computed: {
    colorText() {
      return window.theme.strings.products.product.color;
    },

    identifier() {
      return `product-${this.data.current_product.id}-color`
    },
  },

  methods: {
    getColorString(color) {
      return getColorName(color);
    },

    getSwatchClasses(color) {
      return {
        'active': color.id === this.data.current_product.id,
        'disabled': !color.available,
      };
    },
  },
}
</script>

<style>

</style>